/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
export const getCartridgeType = (type: string): string =>
  type?.includes('_') ? type.split('_')[1] : type;
